import { useEffect, useState, useCallback } from "react"
import MyModal from "../MyModal"
import { getAllUsers } from "../../services/userApis"
import { editTsServer } from "../../services/serverApis"
import actionHelper from "../../lib/actionHelper"
import Input from "../Input"
import useLivePromise from "../../lib/livePromise"
import { useAuth } from "../../lib/useAuth"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"

const EditServerModal = ({ server }) => {
    const { user, isAuthenticated } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const { run } = useLivePromise()

    const [packages, setPackages] = useState(null)
    const [diffPrice, setDiffPrice] = useState(0)
    const [users, setUsers] = useState(null)
    const [isOpen, setIsOpen] = useState(false)

    const handleServerPackageList = useCallback((data) => setPackages(data), [])

    useSocketEvent("serverPackageList", handleServerPackageList)

    useEffect(() => {
        if (isOpen && isAuthenticated) {
            if (user.scope == "admin") {
                getAllUsers()
                    .then((res) => {
                        setUsers(res.data)
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
            sendMessage("getServerPackageList")
        }
    }, [isOpen, isAuthenticated])

    const packageOnChangeCalculator = (evnt) => {
        let packagePriceDifferenceLabel = document.getElementById("packagePriceDifferenceLabel")
        let selectedPackage = packages.find((item) => item.package_name == evnt.target.value)
        let currentPackage = packages.find((item) => item.package_name == server.package_name)
        let serversExpiresInDays = server.expiresInDays - 1
        let remainedServerAmount
        if (selectedPackage == currentPackage) {
            packagePriceDifferenceLabel.innerHTML = null
            return
        }
        if (!serversExpiresInDays || serversExpiresInDays < 0) {
            serversExpiresInDays = 0
        }

        if (currentPackage.package_days) {
            remainedServerAmount = (currentPackage.package_amount / currentPackage.package_days) * serversExpiresInDays
        } else {
            remainedServerAmount = 0
        }

        if (remainedServerAmount - selectedPackage.package_amount < 0) {
            let priceForUser = Math.floor(Math.abs(remainedServerAmount - selectedPackage.package_amount))
            setDiffPrice(`${priceForUser}-`)
            packagePriceDifferenceLabel.innerHTML = `<div class="show_info text-sm mt-2 text-red-400">${priceForUser.toLocaleString(
                "en-US",
            )}- تومان از موجودی شما کم میشود</div>`
        } else {
            let priceForUser = Math.floor(Math.abs(remainedServerAmount - selectedPackage.package_amount))
            setDiffPrice(`${priceForUser}+`)

            packagePriceDifferenceLabel.innerHTML = `<div class="show_info text-sm mt-2 text-green-400">${priceForUser.toLocaleString(
                "en-US",
            )}+ تومان به موجودی شما اضافه میشود</div>`
        }
    }

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const editHandler = (e) => {
        e.preventDefault()
        toggleModal()

        const form = new FormData(e.target)
        let data = {
            serverId: server.id,
            querypassword: form.get("query-password"),
            packageName: form.get("package-name"),
            version: form.get("version"),
            author: form.get("author"),
            subdomain: form.get("subdomain-name"),
            information: form.get("info"),
        }
        actionHelper({
            confirmation: {
                label:
                    diffPrice == 0
                        ? "آیا برای ویرایش سرور مطمئن هستین؟"
                        : `مقدار ${diffPrice} به حساب شما اضافه/کم میشود`,
                actionLabel: "ویرایش سرور",
                color: "warning",
            },

            callback: () =>
                run({
                    job: () => editTsServer(data),
                    subscribeEvent: "server_edit_progress",
                    doneEvent: "server_edit_done",
                    initialPending: "درحال ارسال درخواست به سرور",
                }),
        })
    }

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#3A4B5C" }}
                className="flex gap-2 justify-center border  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
            >
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 24 24"
                    width="25"
                    xmlns="http://www.w3.org/2000/svg"
                    className=" text-xs"
                >
                    <path
                        d="M21.0312 2.96948C22.4286 4.36695 22.4286 6.63268 21.0312 8.03014L18.0393 11.022C17.8618 11.0074 17.6823 11 17.501 11C16.8694 11 16.2588 11.0901 15.6814 11.2581L17.94 8.99939L15.001 6.06039L5.06283 15.9985C4.97054 16.0908 4.90393 16.2055 4.86959 16.3315L3.81974 20.1809L7.66918 19.1311C7.7951 19.0967 7.90988 19.0301 8.00217 18.9378L11.259 15.6808C11.091 16.2581 11.001 16.8685 11.001 17.5C11.001 17.6813 11.0084 17.8608 11.023 18.0384L9.06283 19.9985C8.78596 20.2753 8.44162 20.4752 8.06386 20.5782L2.94817 21.9734C2.38829 22.1261 1.87456 21.6123 2.02726 21.0525L3.42244 15.9368C3.52547 15.559 3.7253 15.2147 4.00217 14.9378L15.9705 2.96948C17.368 1.57202 19.6337 1.57202 21.0312 2.96948ZM17.0312 4.03014L16.061 4.99939L19 7.93939L19.9705 6.96948C20.7822 6.15781 20.7822 4.84182 19.9705 4.03014C19.1588 3.21847 17.8428 3.21847 17.0312 4.03014ZM14.2792 13.9754C14.5939 15.0656 13.9396 16.1991 12.838 16.4716L12.2538 16.6161C12.2089 16.9038 12.1855 17.199 12.1855 17.4998C12.1855 17.8145 12.2111 18.123 12.2601 18.4232L12.7996 18.5532C13.9121 18.8211 14.5734 19.9661 14.2496 21.0636L14.0633 21.6949C14.5024 22.0805 15.0029 22.3937 15.5474 22.6165L16.0407 22.0977C16.8293 21.2685 18.1515 21.2687 18.9398 22.0982L19.4385 22.623C19.9821 22.4027 20.4821 22.0925 20.9213 21.7101L20.7233 21.0242C20.4085 19.9339 21.0629 18.8005 22.1645 18.528L22.7482 18.3835C22.7931 18.0958 22.8165 17.8006 22.8165 17.4998C22.8165 17.1851 22.7909 16.8765 22.7418 16.5762L22.2029 16.4464C21.0904 16.1785 20.4291 15.0335 20.7529 13.9359L20.9391 13.3051C20.4999 12.9193 19.9995 12.6061 19.4549 12.3833L18.9618 12.9018C18.1732 13.7311 16.8509 13.7309 16.0627 12.9013L15.5639 12.3765C15.0203 12.5967 14.5204 12.9068 14.0811 13.2892L14.2792 13.9754ZM17.501 18.9998C16.7004 18.9998 16.0513 18.3282 16.0513 17.4998C16.0513 16.6714 16.7004 15.9998 17.501 15.9998C18.3016 15.9998 18.9507 16.6714 18.9507 17.4998C18.9507 18.3282 18.3016 18.9998 17.501 18.9998Z"
                        fill="#f4f4f5"
                    />
                </svg>
                ویرایش
            </button>
            <MyModal toggleModal={toggleModal} isOpen={isOpen} width="400px" height="450px">
                <div className="">
                    <form onSubmit={editHandler} className="m-2 ml-2">
                        <div className={user && user.scope == "admin" ? "mt-2 grid grid-cols-2 gap-x-5" : "mt-2"}>
                            <Input
                                type="text"
                                dir="ltr"
                                label={"پسورد کوئری"}
                                placeholder={"پسورد کوئری"}
                                defaultValue={server.query_password}
                                name={"query-password"}
                            />
                            {user && user.scope == "admin" ? (
                                <div>
                                    <label className="block">مالک</label>
                                    <select className="styled-select" name="author">
                                        {users &&
                                            users.map((item, index) =>
                                                item.username === server.author ? (
                                                    <option key={index} value={item.username} selected>
                                                        {item.username}
                                                    </option>
                                                ) : (
                                                    <option key={index} value={item.username}>
                                                        {item.username}
                                                    </option>
                                                ),
                                            )}
                                    </select>
                                </div>
                            ) : null}
                        </div>

                        <div className="mt-2">
                            <label className="block">پکیج ها</label>
                            <select
                                class="styled-select"
                                name="package-name"
                                onChange={packageOnChangeCalculator}
                                required
                            >
                                {packages &&
                                    packages.map((item, index) =>
                                        server.package_name == item.package_name ? (
                                            <option key={index} value={item.package_name} selected>
                                                {item.package_description}
                                            </option>
                                        ) : (
                                            <option key={index} value={item.package_name}>
                                                {item.package_description}
                                            </option>
                                        ),
                                    )}
                            </select>
                            <span id="packagePriceDifferenceLabel"></span>
                        </div>
                        <div>
                            <label className="block">ورژن</label>
                            <select class="styled-select" name="version">
                                {server.version == "1.5.6" ? (
                                    <>
                                        <option value="1.5.6" selected>
                                            TeaSpeak 1.5.6
                                        </option>
                                        <option value="1.4.22">TeaSpeak 1.4.22</option>
                                    </>
                                ) : (
                                    <>
                                        <option value="1.5.6">TeaSpeak 1.5.6</option>
                                        <option value="1.4.22" selected>
                                            TeaSpeak 1.4.22
                                        </option>
                                    </>
                                )}
                            </select>
                        </div>
                        <div className="mt-2">
                            <Input
                                type="text"
                                dir="rtl"
                                label={"ساب دامین"}
                                placeholder={"ساب دامین"}
                                defaultValue={server.subdomain_name}
                                name={"subdomain-name"}
                            />
                        </div>
                        <div className="mt-2">
                            <Input
                                type="text"
                                dir="rtl"
                                label={"توضیحات"}
                                placeholder={"توضیحات"}
                                defaultValue={server.info}
                                name={"info"}
                            />
                        </div>

                        <button type="submit" className="styled-button w-full">
                            ویرایش سرور
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

export default EditServerModal
